import React, {useEffect, useRef} from "react";
import {observer} from 'mobx-react-lite'
import systemStore from "../storage/SystemStore";
import appStore from "../storage/AppStore";


const Select = ({store, prop, options, label, for_search=false, ...rest}) => {
  const [opts, setOpts] = React.useState(options)
    useEffect(() => {
      setOpts(options)
    }, [options])
  
    return (
      <select
        className="form-select"
        aria-label={label}
        disabled={systemStore.loading}
        aria-placeholder={label}
        {...rest}
        onChange={(e) => {
            store.setProperty(prop, e.target.value)
        }}
      >
          {for_search && <option value="">{appStore.tr.search_all}</option>}
          {!for_search && <option value="">{label}</option>}
          {opts.map((option, index) => (
            <option key={index} value={option.id} selected={option.id === store[prop]}>{option.name}</option>
          ))}
      </select>
    );
}

export default observer(Select);
